import { initialState } from "./initialState";

// Interfaces for typing
export const PRIORITIES = [
  // matches the order with which the priorities are shown
  "critical",
  "essential",
  "recommended",
  "advanced",
  // "optional",
  // "unknown"
] as const;
// Associated Priority type created from PRIORITIES
export type Priority = typeof PRIORITIES[number];


export interface ChecklistItem {
    checked: boolean;
    priority: Priority;
}


export interface ChecklistSection {
    items: Record<string, ChecklistItem>;
}


export interface ChecklistState {
    [section: string]: ChecklistSection;
}

// Get meta information from state

export function getSectionTotal(
    section: ChecklistSection
): number {
    return Object.keys(section.items).length;
}

export function getSectionPriorityTotal(
    section: ChecklistSection,
    priority: Priority
): number {
    return Object.values(section.items)
        .filter(item => item.priority === priority)
        .length;
}


export function getTotalByPriority(
    state: ChecklistState,
    priority: Priority
): number {
    return Object.values(state)
        .flatMap(section => Object.values(section.items))
        .filter(item => item.priority === priority)
        .length;
}
